import EVENTS from "core/customEvent/events.js";
import _ from "lodash";

import Input from "core/input";

import math from "core/math";

import triggerEvent from "core/customEvent/triggerEvent.js";
import getToolsForElement from "component/molecules/viewport/toolStates/getToolsForElement";
import {
  getters,
  state
} from "component/molecules/viewport/toolStates/store.js";

let isClickEvent = true;
let preventClickTimeout;
const clickDelay = 200;

function getEventButtons(event) {
  if (typeof event.buttons === "number") {
    return event.buttons;
  }

  // eslint-disable-next-line default-case
  switch (Input.Mouse.NormalizeMouseEvent.buttons(event)) {
    // No button
    case 0:
      return 0;
    // Left
    case 1:
      return 1;
    // Middle
    case 2:
      return 4;
    // Right
    case 3:
      return 2;
  }

  return 0;
}

function preventClickHandler() {
  isClickEvent = false;
}

class MouseEventDispatcher {
  constructor() {
    this.viewport = null;
    this.viewportObject = null;

    this.targetElement = null;
  }

  setViewport(viewport) {
    this.viewport = viewport;
  }

  setViewportObject(object) {
    this.viewportObject = object;
  }

  setToolTargetElement = element => {
    this.targetElement = element;
  };

  disableMouseEventListen = () => {
    const targetElement = this.targetElement;
    targetElement.removeEventListener("mousedown", this.onMouseDownHandler);
    targetElement.removeEventListener("mousemove", this.onMouseMoveHandler);
  };

  enableMouseEventListen = () => {
    const targetElement = this.targetElement;
    targetElement.addEventListener("mousedown", this.onMouseDownHandler);
    targetElement.addEventListener(
      "mousemove",
      this.onMouseMoveHandler.bind(this)
    );
  };

  onMouseDownHandler = e => {
    let viewport = this.viewport;
    let viewportObject = this.viewportObject;

    if (typeof viewport === undefined || typeof viewportObject === undefined) {
      return false;
    }

    if (viewport === null || viewportObject === null) {
      return false;
    }

    const imageData = viewportObject.getImage();

    if (!imageData) {
      return;
    }

    const imageIndex = viewportObject.getImageIndex();

    const elementStub = viewportObject.getElementStub(); //elementStub
    //const element = elementStub.element//e.currentTarget;
    const element = e.currentTarget;
    //elementStub.element = element;
    elementStub["element"] = element;

    preventClickTimeout = setTimeout(preventClickHandler, clickDelay);

    element.removeEventListener("mousemove", this.onMouseMovehandler);

    const startPoints = {
      page: math.point.pageToPoint(e),
      //image: pageToPixel(element, e.pageX, e.pageY),
      image: math.coordinate.pageToPixel(elementStub, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY
      }
    };

    startPoints.canvas = math.coordinate.pixelToCanvas(
      elementStub,
      startPoints.image
    );

    let lastPoints = math.copyPoints(startPoints);

    const eventData = {
      event: e,
      buttons: getEventButtons(e),
      viewportObject: this.viewportObject,
      viewport: this.viewport,
      image: imageData,
      imageIndex: imageIndex,
      element: elementStub,
      startPoints,
      lastPoints,
      currentPoints: startPoints,
      deltaPoints: {
        x: 0,
        y: 0
      },
      type: EVENTS.MOUSE_DOWN,
      which: Input.Mouse.NormalizeMouseEvent.buttons(e)
    };

    const eventPropagated = triggerEvent(
      elementStub.element,
      EVENTS.MOUSE_DOWN,
      eventData
    );

    if (eventPropagated) {
      // No tools responded to this event, create a new tool
      eventData.type = EVENTS.MOUSE_DOWN_ACTIVATE;
      triggerEvent(
        eventData.element.element,
        EVENTS.MOUSE_DOWN_ACTIVATE,
        eventData
      );
    }

    function onMouseMove(e) {
      // Calculate our current points in page and image coordinates
      const eventType = EVENTS.MOUSE_DRAG;
      const elementStub = viewportObject.getElementStub(); //elementStub
      elementStub.element = element;

      const currentPoints = {
        page: math.point.pageToPoint(e),
        //image: pageToPixel(element, e.pageX, e.pageY),
        image: math.coordinate.pageToPixel(elementStub, e.pageX, e.pageY),
        client: {
          x: e.clientX,
          y: e.clientY
        }
      };

      currentPoints.canvas = math.coordinate.pixelToCanvas(
        //element,
        elementStub,
        currentPoints.image
      );

      // Calculate delta values in page and image coordinates
      const deltaPoints = {
        page: math.point.subtract(currentPoints.page, lastPoints.page),
        image: math.point.subtract(currentPoints.image, lastPoints.image),
        client: math.point.subtract(currentPoints.client, lastPoints.client),
        canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas)
      };

      const eventData = {
        buttons: getEventButtons(e),
        viewport: viewport,
        viewportObject: viewportObject,
        image: imageData,
        imageIndex: imageIndex,
        //element,
        element: elementStub,
        startPoints,
        lastPoints,
        currentPoints,
        deltaPoints,
        type: eventType,
        ctrlKey: e.ctrlKey,
        metaKey: e.metaKey,
        shiftKey: e.shiftKey,
        which: Input.Mouse.NormalizeMouseEvent.buttons(e)
      };

      triggerEvent(elementStub.element, eventType, eventData);
      lastPoints = math.copyPoints(currentPoints);

      
    }

    // Hook mouseup so we can unbind our event listeners
    // When they stop dragging
    function onMouseUp(e) {
      // Cancel the timeout preventing the click event from triggering
      clearTimeout(preventClickTimeout);
      const elementStub = viewportObject.getElementStub(); //elementStub

      elementStub.element = element;

      let eventType = EVENTS.MOUSE_UP;

      if (isClickEvent) {
        eventType = EVENTS.MOUSE_CLICK;
      }

      // Calculate our current points in page and image coordinates
      const currentPoints = {
        page: math.point.pageToPoint(e),
        //image: pageToPixel(element, e.pageX, e.pageY),
        image: math.coordinate.pageToPixel(elementStub, e.pageX, e.pageY),
        client: {
          x: e.clientX,
          y: e.clientY
        }
      };

      currentPoints.canvas = math.coordinate.pixelToCanvas(
        //element,
        elementStub,
        currentPoints.image
      );

      // Calculate delta values in page and image coordinates
      const deltaPoints = {
        page: math.point.subtract(currentPoints.page, lastPoints.page),
        image: math.point.subtract(currentPoints.image, lastPoints.image),
        client: math.point.subtract(currentPoints.client, lastPoints.client),
        canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas)
      };

      const eventData = {
        event: e,
        viewportObject: viewportObject,
        buttons: getEventButtons(e),
        viewport: viewport,
        image: imageData,
        imageIndex: imageIndex,
        //element,
        element: elementStub,
        startPoints,
        lastPoints,
        currentPoints,
        deltaPoints,
        type: eventType,
        which: Input.Mouse.NormalizeMouseEvent.buttons(e)
      };

      //triggerEvent(eventData.element, eventType, eventData);
      triggerEvent(elementStub.element, eventType, eventData);

      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);

      //element.addEventListener('mousemove', mouseMove);
      element.addEventListener("mousemove", this.onMouseMoveHandler);

      isClickEvent = true;

      // onMouseUp 내부
      const tools = getToolsForElement(elementStub.element, getters.mouseTools());
      
      tools.forEach(tool => {
        if ((tool.name === "Erase" || tool.name === "Pencil") && typeof tool.removeToolData === "function" && tool.mode === "active") {
          // console.log("tool info:", tool);
          tool.removeToolData(eventData);  // erase 도구의 toolData 초기화 등 실행
          // console.log("ERASE MOUSE UP");
          
        }
      });
    }

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    // let callbackFunc = tool["onMouseDown"]
    // callbackFunc()

    return true;
  };

  onMouseMoveHandler(e) {
    let viewport = this.viewport;
    let viewportObject = this.viewportObject;

    if (typeof viewport === undefined || typeof viewportObject === undefined) {
      return false;
    }

    if (viewport === null || viewportObject === null) {
      return false;
    }

    if (viewport === undefined || viewportObject === undefined) {
      return false;
    }

    const element = e.currentTarget;
    const elementStub = viewportObject.getElementStub(); //elementStub
    //const enabledElement = this.element
    const imageData = viewportObject.getImage();
    if (!imageData) {
      return;
    }
    const imageIndex = viewportObject.getImageIndex();
    if (
      !_.get(elementStub, "canvas") ||
      !_.get(elementStub, "image.pixelSpacing")
    ) {
      return;
    }

    const eventType = EVENTS.MOUSE_MOVE;

    const startPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(elementStub, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY
      }
    };

    startPoints.canvas = math.coordinate.pixelToCanvas(
      elementStub,
      startPoints.image
    );

    let lastPoints = math.copyPoints(startPoints);

    // Calculate our current points in page and image coordinates
    const currentPoints = {
      page: math.point.pageToPoint(e),
      image: math.coordinate.pageToPixel(elementStub, e.pageX, e.pageY),
      client: {
        x: e.clientX,
        y: e.clientY
      }
    };

    currentPoints.canvas = math.coordinate.pixelToCanvas(
      elementStub,
      currentPoints.image
    );

    // Calculate delta values in page and image coordinates
    const deltaPoints = {
      page: math.point.subtract(currentPoints.page, lastPoints.page),
      image: math.point.subtract(currentPoints.image, lastPoints.image),
      client: math.point.subtract(currentPoints.client, lastPoints.client),
      canvas: math.point.subtract(currentPoints.canvas, lastPoints.canvas)
    };

    const eventData = {
      viewport: this.viewport,
      viewportObject: this.viewportObject,
      image: imageData,
      imageIndex: imageIndex,
      canvas: element.canvas,
      element: elementStub,
      startPoints,
      lastPoints,
      currentPoints,
      deltaPoints,
      type: eventType,
      which: Input.Mouse.NormalizeMouseEvent.buttons(e)
    };

    triggerEvent(element, eventType, eventData);

    // Update the last points
    lastPoints = math.copyPoints(currentPoints);

    return true;
  }
}

export default MouseEventDispatcher;
